import { MantineProvider as BaseMantineProvider, MantineThemeOverride, PasswordInput } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { DatesProvider } from '@mantine/dates';
import { ReactNode } from 'react';
import 'dayjs/locale/tr';

// Özel koyu mavi renk paleti
const hubBlue = [
  '#f0f1f7',  // 0 - En açık
  '#e1e3ed',  // 1
  '#c3c7d9',  // 2
  '#a4abc5',  // 3
  '#858fb1',  // 4
  '#66739d',  // 5
  '#262a56',  // 6 - Ana renk (primary)
  '#1f2349',  // 7
  '#1a1e3d',  // 8
  '#151831'   // 9 - En koyu
] as const;

// Tema yapılandırması
const theme: MantineThemeOverride = {
  primaryColor: 'hubBlue',
  colors: {
    hubBlue,
  },
  fontFamily: 'Inter, sans-serif',
  defaultRadius: 'md',
  components: {
    Button: {
      defaultProps: {
        size: 'md',
      },
    },
    Input: {
      defaultProps: {
        size: 'md',
      },
    },
    PasswordInput: {
      defaultProps: {
        size: 'sm',
      },
    },
    Tabs: {
      defaultProps: {
        color: 'hubBlue',
      },
    },
    Avatar: {
      defaultProps: {
        color: 'hubBlue',
      },
    },
  },
};

interface MantineProviderProps {
  children: ReactNode;
}

export function MantineProvider({ children }: MantineProviderProps) {
  return (
    <BaseMantineProvider theme={theme}>
      <DatesProvider settings={{ locale: 'tr', firstDayOfWeek: 1, weekendDays: [0, 6] }}>
        <ModalsProvider>
          <Notifications position="top-right" />
          {children}
        </ModalsProvider>
      </DatesProvider>
    </BaseMantineProvider>
  );
}
